var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import DropdownMenu from '../DropdownMenu/DropdownMenu';
import DropdownDivider from '../DropdownMenu/DropdownDivider';
import Field from '../Field/Field';
import { FieldType } from '../_types';
var TableColumnsDropDown = function (props) {
    var _a = props.title, title = _a === void 0 ? 'Visible columns' : _a, _b = props.columns, columns = _b === void 0 ? [] : _b, onVisibleColumnChange = props.onVisibleColumnChange;
    var getInfoMessage = function () {
        return columns && columns.filter
            ? "Selected: " + columns.filter(function (c) { return c.visible; }).length + " / " + columns.length
            : '';
    };
    var renderCheckbox = function (column) {
        var _a;
        var id = column.heading;
        var value = (_a = {},
            _a[id] = column.visible,
            _a);
        return (React.createElement(Field, { value: value, field: {
                name: id,
                heading: column.heading,
                type: FieldType.Checkbox
            }, onChange: function () { return handleVisibleColumnChange(column); } }));
    };
    var handleVisibleColumnChange = function (column) {
        var newColumn = __assign({}, column);
        newColumn.visible = !column.visible;
        return typeof onVisibleColumnChange === 'function'
            ? onVisibleColumnChange(newColumn)
            : null;
    };
    return (React.createElement(DropdownMenu, { iconClass: "fal fa-columns fa-lg" },
        React.createElement("li", { className: "h3 my-0 px-4" }, title),
        React.createElement(DropdownDivider, null),
        React.createElement("li", { className: "mx-4 mb-3" }, "Select columns to display in the table"),
        columns &&
            columns.map(function (column) { return (React.createElement("li", { key: column.heading, className: "dropdown-item" }, renderCheckbox(column))); }),
        React.createElement(DropdownDivider, null),
        React.createElement("li", { className: "float-right mx-4" }, getInfoMessage())));
};
export default TableColumnsDropDown;
